import edmConfig from "url:./edm-demo-config.json";

// Load EDM config
fetch(edmConfig)
  .then((response) => response.json())
  .then((json) => {
    window.addEventListener("message", () => {
      const edmIframe = document.getElementById("edm-iframe");

      if (edmIframe) edmIframe.contentWindow.postMessage(`edm|${JSON.stringify(json)}`, "*");
    });
  });

window.addEventListener(
  "message",
  (e) => {
    const key = e.message ? "message" : "data";
    const data = e[key];
    const preIframeContent = document.getElementById("pre-iframe-content");

    if (preIframeContent) {
      if (data === "edm|navigatedToEvent" || data === "edm|navigatedToLecturer" || data === "edm|navigatedToLocation") {
        hideElement(preIframeContent);
      } else if ((data === "edm|navigatedToEventList") | (data === "edm|navigatedToLecturerList") | (data === "edm|navigatedToLocationList")) {
        showElement(preIframeContent);
      }
    }
  },
  false
);

document.addEventListener("DOMContentLoaded", function () {
  handleNavbarItemActiveState("/events", "nav-events");
  handleNavbarItemActiveState("/lecturers", "nav-lecturers");
  handleNavbarItemActiveState("/locations", "nav-locations");
  handleNavbarItemActiveState("/about", "nav-about");

  Iodine.setErrorMessages({
    required: "Bitte füllen Sie dieses Pflichtfeld aus.",
    email: "Bitte geben Sie eine gültige E-Mail-Adresse an.",
  });
});

const handleNavbarItemActiveState = (path, id) => {
  if (window.location.pathname.includes(path)) {
    document.getElementById(id).classList.add("active");
  } else {
    document.getElementById(id).classList.remove("active");
  }
};

const showElement = (elem) => {
  elem.style.display = "block";
};

const hideElement = (elem) => {
  elem.style.display = "none";
};
